"use client";

import { cn } from "@/lib/utils";
import { Tab } from "@headlessui/react";
import Image from "next/image";
import Communities from "./communities";
import Products from "./products";
import People from "./people";
import { usePathname } from "next/navigation";
import useCommunityAndChannelParams from "@/hooks/useChannelAndCommunityParams";
import CountryPortalsList from "./country-portals";

const HomeCommunitiesPopular = () => {
  const { communitySlug } = useCommunityAndChannelParams();
	const pathname = usePathname();
	const tabs = ["Communities", pathname === `/communities/${communitySlug}/home` ? "People" : "Country Portals", "Products"];

	return (
		<>
			<div className="relative mt-8 min-h-[28rem] w-full bg-gradient-radial from-[#d3e2ff] via-[#e0ebff] to-[#fafbff] bg-cover bg-no-repeat py-12 sm:mt-16">
				<div className="w-1/8 absolute left-0 top-0 h-full opacity-40 sm:opacity-100">
					<Image
						src="/images/home/categories-section-left.png"
						alt="Categories Section Left"
						height={400}
						width={400}
						className="h-full w-full object-cover"
					/>
				</div>
				<div className="w-1/8 absolute right-0 top-0 hidden h-full md:block">
					<Image
						src="/images/home/categories-section-right.png"
						alt="Categories Section Right"
						height={400}
						width={400}
						className="h-full w-full object-cover"
					/>
				</div>
				<Tab.Group as="div" className="mx-auto w-11/12 max-w-[49rem] overflow-hidden  lg:w-full">
					<Tab.List className="relative flex justify-center gap-0.5">
						{tabs.map((tabName) => (
							<Tab
								key={tabName}
								className={({ selected }) =>
									cn(
										"w-fit -skew-x-[8deg] px-4 py-3 text-center text-sm font-bold transition-all hover:bg-brand-primary hover:text-white hover:opacity-50 sm:text-lg md:px-6",
										selected
											? "bg-brand-primary text-white outline-none hover:opacity-100"
											: "bg-white font-semibold text-gray-400"
									)
								}
							>
								{tabName}
							</Tab>
						))}
					</Tab.List>

					<Tab.Panels>
						<Tab.Panel>
							<Communities />
						</Tab.Panel>
						<Tab.Panel>
							{
                pathname === `/communities/${communitySlug}/home` ? <People /> : <CountryPortalsList />
              }
						</Tab.Panel>
						<Tab.Panel>
							<Products />
						</Tab.Panel>
					</Tab.Panels>
				</Tab.Group>
			</div>
		</>
	);
};

export default HomeCommunitiesPopular;
